import { CustomerRegistrationCountries } from '../enums/customerRegistrationCountries';
import { IsoCurrencyCode } from '../types/api';

export const defaultCurrencies: Record<string, IsoCurrencyCode> = {
  [CustomerRegistrationCountries.CZ]: IsoCurrencyCode.CZK,
  [CustomerRegistrationCountries.SK]: IsoCurrencyCode.EUR,
  [CustomerRegistrationCountries.NL]: IsoCurrencyCode.EUR,
};
